/* eslint-disable no-async-promise-executor */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Injectable } from '@angular/core';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { ViewportScroller } from '@angular/common';
import { DataService } from './data.service';
import { ChatMessage } from '../models/chat-message.interface';
import { PromptData } from '../models/prompt-data.interface';
import { TrainedQuestion } from '../models/trained-question.interface';
import { ErrorService } from './error.service';
import { FilterResultService } from './filter-result/filter-result.service';
import { ProcessType } from '../configs/process-type.config';

@Injectable({
  providedIn: 'root'
})

export class UtilsService {

  constructor(private userService: UserService, private router: Router, private menuController: MenuController, private viewportScroller: ViewportScroller, private dataService: DataService,private errorService:ErrorService,private filterService:FilterResultService) { }


  isOldConversations: boolean = false;
  isNewConversations: boolean = false;
  lessConversation: boolean = false;

  deleteConfirmationAlert: any = false;
  deleteAllConfirmationAlert: any = false;
  deleteAllEnabled: boolean = false;

  isFirstQuery: boolean = true;
  starredData: boolean = false;
  dataLoaded: boolean = true;
  detailsEdit: boolean = false;

  filterMenuOpen: boolean = false;
  promptMenuOpen: boolean = false;
  isMenuOpen: boolean = false;
  activeTabIndex: number = 0;

  resizePromptMenu: boolean = false;
  resizeFilterMenu: boolean = false;
  resizeChatMenu: boolean = false;

  trainerMode: boolean = false;
  retryMode: boolean = false
  filterDataLoaded:boolean=false;
  initializeVersion:boolean=false;

  suggestedFaqs: any = [];
  starredFaqs: any = [];
  chartData: any;
  oldConversations: any = [];
  Conversations: any = [];
  updatedConversations: any = [];
  conversationData: any = [];
  updatedChatMessages: ChatMessage[] = [];
  trainedQuestions: TrainedQuestion[] = [];
  filteredResults:any;
  chart:any;

  inputPlaceholder: string = "";
  selectedIndex: number = -1;
  conversationTitle: string = 'New Chat';
  userLogoText: string = '';

  conversationId: string | null = null;
  newConversationId: string | null = null;

  generatedSql: string = ""
  generatedPrompt: any = ''
  generatedQuestion: string = ""
  generatedLLMResponse:string=""
  generatedSimilarities:string=""
  genratedType:string=""
  sqlErr:string=""

  returnUrl: string = '/';
  questionBackround: string = ""

  trainedQuestionInfo:any={}

  currentVersion:number=1
  selectedVersion:number=1
  trainedQuestionVersions:any=[]
  trainingId:any;
  feedback:number|undefined;
  likeImage: string = 'right-inactive';
  disLikeImage: string = 'wrong-inactive';
  detailsChanged:boolean=true;
  filterDataNotFound:boolean=false;
  promptDataLoaded=true;
  updatedProcessTypes=ProcessType;
  questionId:any=0;
  token:any=0;
  cid:any=0;
  qid:any=0;


  

  updatedPromptDetails: PromptData[] = [
    {
      type: 'Question',
      details: this.generatedQuestion,
      isEdit: false,
      editDisabled: false,
      readOnly:false,
      errMsg:''
    },
    {
      type: 'LLM Prompt',
      details: this.generatedPrompt,
      isEdit: false,
      editDisabled: false,
      readOnly:false,
      errMsg:''
    },
    {
      type: 'SQL Prompt',
      details: this.generatedSql,
      isEdit: false,
      editDisabled: false,
      readOnly:false,
      errMsg:''
    },
    {
      type: 'LLM Response',
      details:"",
      isEdit: false,
      editDisabled: false,
      readOnly:true,
      errMsg:''
    },
    {
      type: 'Similarity Results',
      details: "",
      isEdit: false,
      editDisabled: false,
      readOnly:true,
      errMsg:''
    },

  ]

  setConversationId(cId: string | null) {
    this.conversationId = cId;
  }
  getConversationId() {
    return this.conversationId;
  }
  setReturnUrl(url: string) {
    this.returnUrl = url;
  }
  logout(): void {
    this.userService.clearUser();
    
    this.userService.clearAnswerMode();
    this.userService.clearTrainerMode();
    this.trainerMode = false
    const queryParams = this.userService.getOrgId() ? { org_id: this.userService.getOrgId() } : {};

    this.router.navigate(['/login'], {
      queryParams,
    
    });

  }
  menuToggle() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.menuController.close('mob-chat-menu');
  }
  openMenu() {

    this.menuController.open('mob-chat-menu');
  }
  setUserLogoText() {
    this.userLogoText = this.userService.getUserLogoInitials() || '';
    return this.userLogoText;
  }
  isQuestionStarred(question: string) {
    let starred = false
    starred = this.starredFaqs.some((item: any) => {
      return item.question === question;
    });
    this.preventAutoScroll();
    return starred;
  }
  preventAutoScroll(): void {

    const currentPosition = this.viewportScroller.getScrollPosition();
    this.viewportScroller.scrollToPosition(currentPosition);
  }
  getStarredQuestions() {
    this.starredData = true
    this.dataService.getStarredQuestions().subscribe((res) => {
      this.starredFaqs = res.data
      if (this.starredFaqs.length == 0) {
        this.starredData = false;
      }
      else {
        this.starredData = true;

      }
    })

  }
  addStarredQuestion(question: string) {
    this.dataService.addStarredQuestion(question).subscribe((res) => {
      this.oldConversations.forEach((message: any) => {
        if (message.role === 'user' && message.content === question) {
          message.is_starred = true;
        }
      });
      this.getStarredQuestions();

      this.preventAutoScroll();

    })
  }
  unStarredQuestion(question: string) {
    const sq = this.starredFaqs.filter((item: any) => {
      if (item.question === question) {
        this.dataService.deleteStarredQuestion(item.pid).subscribe((res) => {
          this.oldConversations.forEach((message: any) => {
            if (message.role === 'user' && message.content === question) {
              message.is_starred = false;
            }
          });
          this.getStarredQuestions();
        });
        this.preventAutoScroll();
      }

    });

  }
  setPlaceholder(isFaq: boolean) {
    const user = this.userService.getUser();
    if (isFaq && user?.name) {
      this.inputPlaceholder = 'Hi ' + user.name.trim().split(' ')[0] + ', please select an FAQ or feel free to ask a question';
    } else {
      this.inputPlaceholder = 'Enter your query here';
    }
    return this.inputPlaceholder
  }
  addConversationMessages(resultIndex?: any, answerMode?: any) {
    let  conversationItemX =[];
    let newObject= false;
    if(this.conversationData.length!=0){
     conversationItemX = this.conversationData.find((convo: { conversationId: any; }) => convo.conversationId === this.conversationId);
     if(conversationItemX!=undefined){
      newObject=resultIndex>=conversationItemX.conversation.length?true:false
     }
    }
    
    const conversationObject = {
      conversationId: this.conversationId,
      conversation: this.oldConversations
    };
   
    if (resultIndex == undefined || resultIndex == null || newObject) {

      const existingIndex = this.conversationData.findIndex((convo: { conversationId: any; }) => convo.conversationId === this.conversationId);
      if (existingIndex == -1) {
        this.conversationData.push(conversationObject);
      }
      else if (this.conversationData.length !== this.oldConversations) {
        this.conversationData[existingIndex] = conversationObject
      }
    }
 
    else {
     
      const conversationItem = this.conversationData.find((convo: { conversationId: any; }) => convo.conversationId === this.conversationId);
      if (conversationItem) {
        const existingIndex = this.conversationData.findIndex((convo: { conversationId: any; }) => convo.conversationId === this.conversationId);

        conversationItem.conversation[resultIndex].answer_mode = answerMode
        this.oldConversations = conversationItem.conversation
        const conversationObject = {
          conversationId: this.conversationId,
          conversation: this.oldConversations
        };
        this.conversationData[existingIndex] = conversationObject
        return conversationItem.conversation;

      } else {

        return null;
      }
    }
    
  }
  getConversationMessages(conversationId: any) {
    const conversationItem = this.conversationData.find((convo: { conversationId: any; }) => convo.conversationId === conversationId);
    if (conversationItem) {
      return conversationItem.conversation
    }
    else {
      return null
    }
   
  }

  getTrainerMode() {
    this.trainerMode = this.userService.getTrainerMode();
    return this.trainerMode

  }

  reGenerateSql(updatedPrompt: any, promptType: string,resultIndex:any) {
    if(promptType==='Question'){
      if(this.generatedQuestion===updatedPrompt){
        this.detailsChanged=false
      }
      else{
        this.detailsChanged=true
      }
    }
    else if(promptType==='LLM Prompt'){
      if(this.generatedPrompt===updatedPrompt){
        this.detailsChanged=false
      }
      else{
        this.detailsChanged=true
      }
    }
    else if(promptType==='SQL Prompt'){
      if(this.generatedSql===updatedPrompt){
        this.detailsChanged=false
      }
      else{
        this.detailsChanged=true
      }
    }
    const baseBody = {
      'question': this.generatedQuestion,
      'user_id': this.userService.getUserId(),
      'org_id': this.userService.getOrgId() === 0 ? 1 : this.userService.getOrgId(),
      'trainer_mode': this.trainerMode,
      'retry_mode': true,
    };
    const conversationBody = this.getConversationId() ? { 'conversation_id': this.getConversationId() } : {};
    let promptSpecificBody: any;

    switch (promptType) {
      case 'Question':
        promptSpecificBody = {
          'updated_question': updatedPrompt,
          'updated_prompt': this.generatedPrompt?JSON.parse(this.generatedPrompt):'',
        };
        this.generatedQuestion=updatedPrompt
        break;

      case 'LLM Prompt':
        promptSpecificBody = {
          'updated_prompt': JSON.parse(updatedPrompt),
        };
        break;

      case 'SQL Prompt':
        promptSpecificBody = {
          'updated_sql': updatedPrompt,
          'updated_prompt': this.generatedPrompt?JSON.parse(this.generatedPrompt):'',
        };
        break;

      default:
        throw new Error("Invalid promptType");
    }
    const body = { ...baseBody,...conversationBody,...promptSpecificBody };
   
    const results = this.dataService.generateResults(body).subscribe((res) => {
     
      if(res.results==null || res.results.length==0){
        this.updatedChatMessages=this.updatedChatMessages.map(item=>{
          if (item.hasOwnProperty('resultIndex') && item.resultIndex === resultIndex){

          return {
            isUser: item.isUser,
            result:{
              error: this.errorService.getErrorMessage(202),
            },
            trainingInfo:item.trainingInfo,
          };
        }
        return item
        })
      }
      else{

        this.updatedChatMessages= this.updatedChatMessages.map(item => {
          // Check if the item has a resultIndex property and if it matches the target resultIndex
          
          if (item.hasOwnProperty('resultIndex') && item.resultIndex === resultIndex) {
            // Create a new object with the updated properties
            return {
              ...item,
              result: res.results,
              question: res.generatedQuestion,
              generatedSql:res.generated_sql ,
              // Keep all other properties the same
              llmPrompt: item.llmPrompt,
              id: item.id,
              isUser: item.isUser,
              answerMode: item.answerMode,
              filterEnabled: item.filterEnabled,
              activeQuestion: item.activeQuestion,
              trainingInfo:item.trainingInfo,
              activeQuestionColor: item.activeQuestionColor,
              trainingDataID:item.trainingDataID,
              resultIndex:item.resultIndex,
              feedback:undefined
            };
          }
          return item;
        });
        
      }
      this.feedback=undefined
      this.detailsEdit = true
      this.generatedSql = res.generated_sql
      this.generatedPrompt = res.prompt!=null?JSON.stringify(res.prompt):''
      this.generatedLLMResponse=res.llm_intent_response!=null?JSON.stringify(res.llm_intent_response):''
      this.generatedSimilarities = res.similarity_results!=null?JSON.stringify(res.similarity_results):''
      if(res.error){
        this.sqlErr=res.error
      }
      else{
        this.sqlErr=''
      }
      this.updatePromptDetails();
      this.updateTrainedQuestion(this.generatedQuestion, this.generatedPrompt, this.generatedSql,this.generatedLLMResponse,this.generatedSimilarities,this.genratedType)
    })
   
  }
  updatePromptDetails() {
  
    this.updatedPromptDetails = this.updatedPromptDetails.map(item => {
      return {
        ...item,
        details: this.getUpdatedDetails(item.type),
        errMsg:this.getErrorDetails(item.type)
      };
    });
    this.promptDataLoaded=true

  }
  getErrorDetails(type: string): string {
    switch (type) {
      case 'Question':
        return '';
      case 'LLM Prompt':
        return '';
      case 'SQL Prompt':
        return this.sqlErr;
      case 'LLM Response':
        return '';
      case 'Similarity Results':
        return '';
      default:
        return '';
    }
  }
  getUpdatedDetails(type: string): string {
    switch (type) {
      case 'Question':
        return this.generatedQuestion;
      case 'LLM Prompt':
        return this.generatedPrompt;
      case 'SQL Prompt':
        return this.generatedSql;
      case 'LLM Response':
        return this.generatedLLMResponse;
      case 'Similarity Results':
        return this.generatedSimilarities;
      default:
        return '';
    }
  }updateTrainedQuestion(
    questionX: string,
    promptX: any,
    sqlX: string,
    llmResponseX?: any,
    similarityResponseX?: any,
    processTypeX?: any
  ) {
    // Find the index of the question that matches the provided questionX
    const index = this.trainedQuestions.findIndex(
      (item) => item.question === questionX
    );
  
    if (index !== -1) {
      // If the question already exists, update the existing question
      this.trainedQuestions[index] = {
        ...this.trainedQuestions[index], // Keep the existing properties
        question: questionX,
        prompt: promptX,
        sql: sqlX,
        llmResponse: llmResponseX,
        similarity: similarityResponseX,
        processType: processTypeX,
        activated: false, // Or true depending on your logic
      };
    } else {
      // If the question doesn't exist, add a new trained question
      const trainedQuestion: TrainedQuestion = {
        id: this.trainedQuestions.length + 1,
        question: questionX,
        prompt: promptX,
        sql: sqlX,
        activated: false, // Or true depending on your logic
        llmResponse: llmResponseX,
        similarity: similarityResponseX,
        processType: processTypeX,
      };
      this.trainedQuestions.push(trainedQuestion);

    }
  }
  
  getTrainedPromptDetails(question: string, id: any) {
    this.generatedQuestion = question
    const trainedQuestion = this.trainedQuestions.filter((item) =>
      item.question === question)
    this.generatedQuestion = trainedQuestion[trainedQuestion.length - 1].question
    this.generatedPrompt = trainedQuestion[trainedQuestion.length - 1].prompt
    this.generatedSql = trainedQuestion[trainedQuestion.length - 1].sql
    this.generatedLLMResponse=trainedQuestion[trainedQuestion.length - 1].llmResponse
    this.generatedSimilarities = trainedQuestion[trainedQuestion.length - 1].similarity
    this.genratedType=trainedQuestion[trainedQuestion.length - 1].processType
    this.updatePromptDetails();
    const activatedQuestion = this.updatedChatMessages.filter((item) =>
      item.id === id)
    this.updatedChatMessages.forEach(item => {
      if (item.id === id) {
     
        item.activeQuestion = true;
        item.activeQuestionColor = this.trainerMode ? item.activeQuestion ? 'white' : 'white' : '#CFCFCF'
      }
      else {
        item.activeQuestion = false;
        item.activeQuestionColor = this.trainerMode ? item.activeQuestion ? 'white' : 'white'  : '#CFCFCF'
      }
    });
  }
  updateResults(index?: any,) {
    if (this.filterMenuOpen) {
     
      this.updatedChatMessages.forEach(item => {
       
        if (index === item.resultIndex) {
        
          item.filterEnabled = true
        }
        else {
         
          item.filterEnabled = false
        }
      })
    }
    else {
     
      this.updatedChatMessages.forEach(item => {
        item.filterEnabled = false
      })
    }
  }
  closeTabMenu(){
    this.promptMenuOpen=false
    this.filterMenuOpen=false
    if (this.updatedChatMessages.length > 1) {
      this.updatedChatMessages.forEach(item => {
          item.activeQuestion = false;
          item.activeQuestionColor = this.trainerMode ? 'white' : '#CFCFCF'
      });
    }
  this.filterMenuOpen=false;
  this.updateResults()
  }
  updateTrainedQuestionInfo(question:any,trainingInfo:any){
    const trainedQuestionInfo = {
      question: question,
      trainingInfo:trainingInfo
    }
    if(this.trainedQuestionInfo.length==0){
      this.trainedQuestionInfo.push(trainedQuestionInfo)
    }
    // else{
    //   if(this.trainedQuestionInfo.includes(question)){
    //     this.trainedQuestionInfo.forEach((item)=>{

    //     })
    //   }
    // }
  }
  getVersion(resultIndex?:any){
     
      const data=this.trainedQuestionVersions.filter((item: { version_number: any; })=>{
      
        return item.version_number===this.selectedVersion
      }) 
      if(data[0].promt!="" ||data[0].promt!=null){
        this.generatedPrompt=''
      }
    
      this.generatedSql=data[0].sql_query
      this.feedback=data[0].feedback  
      // this.generatedLLMResponse=""
      // this.generatedSimilarities = ""
     
      this.updateFeedback(resultIndex)
      
      this.updateTrainedQuestion(data[0].question,(data[0].promt!="" || data[0].promt!=null)?JSON.stringify(data[0].promt):'',data[0].sql_query,this.generatedLLMResponse,this.generatedSimilarities)
      this.updatePromptDetails();
     
  }
  async getVersions(trainingID:any,resultIndex?:any,newVersion?:boolean,) {
   
    await this.dataService.getTrainingDataVersions(trainingID).subscribe({
      next: (res) => {
        this.trainedQuestionInfo = res;
       
        this.trainedQuestionVersions = res.versions;
        this.currentVersion=res.current_version
        if(newVersion!==false){
        this.selectedVersion=res.current_version
        }
        this.trainingId=res.training_data_id
        
          this.getVersion()
        
       
        
        
        return this.trainedQuestionInfo
      },
      error: (err) =>{console.error("Error:", err)
        this.currentVersion=0
        this.selectedVersion=0
      }
    });
  }
  updateFeedback(resultIndex: any) {
 
    this.updatedChatMessages = this.updatedChatMessages.map(item => {
      // Check if the item has a resultIndex property and if it matches the target resultIndex
      if (item.hasOwnProperty('resultIndex') && item.resultIndex === resultIndex) {
        // Create a new object with the updated feedback only
        return {
          ...item,  
          trainingInfo:true,             // Spread the existing properties of the item
          feedback: this.feedback,
       // Update only the feedback property
        };
      }
      return item; // Return the item as is if resultIndex doesn't match
    });
  
  }
  async getGraphData(generatedSql: string, resultIndex?: any, results?: any) {
    this.filterDataLoaded = false;
    this.filterMenuOpen = true;
  
    // Return a promise that resolves when the data is fetched
    return new Promise<any>(async (resolve, reject) => {
      try {
        this.dataService.getGraph(generatedSql).subscribe(async (res) => {
          if (res && res.metadata) {
            this.filterDataLoaded = true;
            this.filterDataNotFound = false;
            
            // Save filter data and resolve with the metadata
            await this.saveGraphData(resultIndex, this.chart, res.metadata);
            resolve(res.metadata);
          } else {
            reject(new Error('No metadata returned from the graph API'));
          }
        },
        (err) => {
          this.filterDataLoaded = true;
          this.filterDataNotFound = true;
          console.error('Error fetching graph data:', err);
          reject(err);
        });
      } catch (err) {
        reject(err);
      }
    });
  }
  
  getGraPH(createChart?:any,generatedSql?:any){
      const graphDatasets=this.getGraphData(generatedSql)
  }
  saveGraphData(resultIndex: number, chart: any, graphDatasets: any[],) {
    const id = `message-${resultIndex}`;
    this.filterService.setGraphData(id, {
      resultIndex,
      chart,
      graphDatasets
    });
    return id
  }
  saveResultData(resultIndex: number,results: any[]){
    const id = `message-${resultIndex}`;
    this.filterService.storeOriginalResults(id, {
       results:results 
    });
    return id
  }
  saveFilterData(resultIndex: number,data: any){
    const id = `message-${resultIndex}`;
    this.filterService.setFilterData(id, {
       resultIndex:resultIndex,
       data:data
    });
    return id
  }
  clearDataStore(){
    this.filterService.clearFilterData();
    this.filterService.clearResultData();
    this.filterService.clearGraphData();
  }
}